var _920 = require('./patch/9.2.0');

module.exports = [].concat(_920);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@dp/knb/compiled/titans/dp/dp.js
// module id = lhbC
// module chunks = 0